import Booking, { loadBookingFromCache, } from "./shared/functions/booking";
import { hasCacheExpired, hasCanceledFlag } from "./shared/functions/booking";
import { getBookingByNr, getBookingNr } from "./shared/functions/booking";
import { SessionStore, TestStore } from "./shared/functions/store";
import { isExcludedCard } from "./mithril/uebersicht/shared/model";
import { logError } from "./shared/functions/misc";
import Gateway from "@phoenixreisen/gateway";
import User from "@phoenixreisen/user";
import DateTime from "date-and-time";
import Config from "./config";
import de from "date-and-time/locale/de";
import "./shared/fonts/titillium";
import "./shared/fonts/font-awesome";
export const bootstrapOptions = {
    bookingSize: "L",
    bookingCard: null,
    isPasswordProtected: true,
    redirectIfNotExists: true,
    redirectIfNoBooking: true,
    redirectIfNotAuthed: true,
};
export default {
    storageAvailable() {
        try {
            TestStore.set("test", "passed");
            TestStore.get("test");
            TestStore.remove("test");
            return true;
        }
        catch {
            return false;
        }
    },
    init(service) {
        DateTime.locale(de);
        Config.service = service;
        Config.env = process.env;
        Config.urls = process.urls;
        Gateway.setMaxRetries(1);
        Gateway.setLogger(logError);
        Gateway.setApiErrorUrl(Config.urls.API_ERROR);
        Gateway.setApiUrl(`${Config.env.GATEWAY}/call-json-service`);
        if (this.storageAvailable()) {
            User.setJWTKey(Config.storageKeyJWT);
            User.load();
            const cachedBooking = loadBookingFromCache();
            if (cachedBooking) {
                Booking.data = cachedBooking.data || null;
                Booking.size = cachedBooking.size || undefined;
                Booking.changed = cachedBooking.changed || undefined;
            }
        }
    },
    async initServiceWorker(rerender) {
        if ("serviceWorker" in navigator) {
            try {
                const registrations = await navigator.serviceWorker.getRegistrations();
                if (registrations.length > 0) {
                    console.warn("Removing outdated service worker...");
                    for (const registration of registrations) {
                        await registration.unregister();
                    }
                    const cacheNames = await caches.keys();
                    for (const cacheName of cacheNames) {
                        await caches.delete(cacheName);
                    }
                    console.warn("Service worker and caches removed");
                }
            }
            catch {
            }
            window.addEventListener("online", () => {
                User.online = navigator.onLine;
                rerender?.();
            }, false);
            window.addEventListener("offline", () => {
                User.online = navigator.onLine;
                rerender?.();
            }, false);
        }
    },
    async bootstrap(options = {}) {
        const checks = Object.assign({}, bootstrapOptions, options);
        const { urls, storageKeyReferrer } = Config;
        const { bookingCard, isPasswordProtected, redirectIfNotAuthed, redirectIfNotExists, redirectIfNoBooking, } = checks;
        if (!User.isLoggedIn()) {
            location.href = urls.LOGIN;
        }
        else if (isPasswordProtected && !User.isPasswordAuthenticated()) {
            location.href = urls.PASSWORD_SET;
        }
        else if (!getBookingNr(User) &&
            (User.isPhx() || User.isAgency()) &&
            redirectIfNoBooking) {
            location.href = urls.TAKE_OVER;
        }
        else if (!getBookingNr(User) && !User.isPhx() && redirectIfNoBooking) {
            location.href = urls.LOGOUT;
        }
        else if (getBookingNr(User)) {
            const force = hasCacheExpired(Booking.changed);
            await getBookingByNr(getBookingNr(User), force, checks.bookingSize)
                .then((booking) => {
                if (hasCanceledFlag(booking) && !User.isPhx()) {
                    throw new Error("canceled");
                }
                if (bookingCard && isExcludedCard(bookingCard, booking)) {
                    throw new Error("excluded");
                }
                return booking;
            })
                .then((booking) => {
                const cruisetime = booking["buchung/reisezeitraum"] || null;
                if (cruisetime) {
                    const endDate = DateTime.parse(cruisetime[1], "DD.MM.YYYY");
                    const inclusiveEnd = DateTime.addDays(endDate, -1);
                    cruisetime[1] = DateTime.format(inclusiveEnd, "DD.MM.YYYY");
                }
                return booking;
            })
                .catch((error) => {
                switch (error.message) {
                    case "excluded":
                        location.href = Config.urls.OVERVIEW;
                        break;
                    case "canceled":
                        location.href = Config.urls.CANCELED;
                        break;
                    case "unauthorized":
                        if (redirectIfNotAuthed) {
                            SessionStore.set(storageKeyReferrer, location.href);
                            location.href = urls.PASSWORD_PROTECT;
                        }
                        break;
                    case "unverified":
                        SessionStore.set(storageKeyReferrer, location.href);
                        location.href = urls.LOGOUT;
                        break;
                    case "not-found":
                        if (redirectIfNotExists) {
                            location.href = urls.LOGOUT;
                        }
                        break;
                    default:
                        logError(error);
                        location.href = urls.API_ERROR;
                }
            });
        }
    },
};
